
// Vue
import {Options, Vue} from "vue-class-component";

// Store
import store from "@/store";

// Vendors
import moment from "moment";

// Models
import {AppCoachTrainingsRootListIndex} from "@/models/app/coach/trainings/root/list/index";
import {AppCommonUser} from "@/models/app/common/User";
import {AppCommonTrainingCategory} from "@/models/app/common/training-category";
import {ResponseIndex} from "@/models/response";

// Components
import {
  ElRow,
  ElCol,
} from "element-plus";
import AppCoachTrainingsRootListFormCreateIndexVue from "@/views/app/coach/trainings/root/list/form/create.vue";
import AppCoachTrainingsRootListFormUpdateIndexVue from "@/views/app/coach/trainings/root/list/form/update.vue";
import AppCoachTrainingsRootListFormRemoveIndexVue from "@/views/app/coach/trainings/root/list/form/remove.vue";

// Services
import {getRequest} from "@/services/api/request";

@Options({
  props: [
    "players",
    "trainingCategories",
  ],
  components: {
    ElRow,
    ElCol,
    AppCoachTrainingsRootListFormCreateIndexVue,
    AppCoachTrainingsRootListFormUpdateIndexVue,
    AppCoachTrainingsRootListFormRemoveIndexVue,
  },
})
export default class AppCoachTrainingsRootListIndexVue extends Vue {
  isLoading: boolean | null = false;
  formData: any = {
    filter: {
      user_id: "*",
      training_category_id: "*",
      date: [
        moment(),
        moment().add(14, "days"),
      ],
    },
    organization_id: store.getters.getOrganizationMember.organization_id,
  };
  moment: any = null;

  players: Array<AppCommonUser> = [];
  trainingCategories: Array<AppCommonTrainingCategory> = [];

  trainings: Array<AppCoachTrainingsRootListIndex> = [];

  async getTrainings(formData: any = null): Promise<void> {
    this.isLoading = true;

    if (formData) {
      this.formData = formData;
    }

    await getRequest({
      uri: `/common/trainings`,
      formData: this.formData,
      isProtected: true,
    }).then((r: ResponseIndex) => {
      if (r.data) {
        this.trainings = r.data;
      }
    });
    this.isLoading = false;
  }

  async created(): Promise<void> {
    this.moment = moment;
    await this.getTrainings();
  }
}
